<template>
  <van-swipe
    v-if="showCount"
    class="lazy_img"
    :show-indicators="false"
    :autoplay="3000"
    lazy-render
  >
    <van-swipe-item v-for="(item, index) in activityIamge" :key="index">
      <a
        v-if="item.url != null"
        class="lazy_img"
        :href="item.url"
        target="_blank"
        ><img class="lazy_img" :src="item.image"
      /></a>
      <img v-else class="lazy_img" :src="item.image" />
    </van-swipe-item>
  </van-swipe>
  <img
    v-if="!showCount"
    class="lazy_img"
    :src="require('../assets/img/history.jpg')"
  />
  <div v-if="showCount">
    <div v-if="time >= 0 && applyStarttime < curtime">
      <van-count-down
        class="count-text"
        :time="time"
        :format="`距离本期（${startTime}-${endTime}）投票结束还有：DD 天 HH 时`"
      />
    </div>
    <van-count-down
      class="count-text"
      v-else-if="applyStarttime > curtime"
      :time="applyStarttime - curtime"
      :format="`距离本期（${startTime}-${endTime}）投票开始还有：DD 天 HH 时`"
    />
    <div class="end-text" v-else>投票已结束</div>
  </div>
  <div class="activity-btn" v-if="showCount" @click="handleClick()">
    往期活动
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, onMounted, ref } from "vue";
import { CountDown, Swipe, SwipeItem } from "vant";
import { useRouter, useRoute } from "vue-router";
// import "@/plugins/vconsole.js";

export default {
  name: "HomeHeader",
  components: {
    [CountDown.name]: CountDown,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const showCount = ref(true);

    if (route.path === "/activity/") showCount.value = false;

    // const termId = computed(() => {
    //   return store.state.termId;
    // });
    // console.log(termId);

    onMounted(() => {
      //   store.dispatch("getAppEnv", {}).then(() => {
      //     // console.log("有没有id", store.state.termId);
      //     let id = store.state.termId;
      //     let params = {
      //       term_id: id,
      //     };
      //     console.log(params);
      //     store.dispatch("getCanVote", { params });
      //   });
    });

    const handleClick = () => {
      // console.log("有没有id", store.state.termId);
      let id = store.state.termId;
      if (route.path == "/activity/") router.push("/");
      if (route.path == "/activity_view/") router.push("/activity/?id=" + id);
      if (route.path == "/") router.push("/activity/?id=" + id);
      // router.push("/activity/");
    };

    const imageyFn = (image) => {
      console.log(image);
    };

    return {
      showCount,
      imageyFn,
      handleClick,
      time: computed(() => store.state.countDown),
      covers: computed(() => store.state.covers),
      activityIamge: computed(() => store.state.activityIamge),
      applyStarttime: computed(() => store.state.applyStarttime),
      curtime: computed(() => store.state.curtime),
      startTime: computed(() => store.state.startTime),
      endTime: computed(() => store.state.endTime),
    };
  },
};
</script>

<style lang="scss" scoped>
// .swiper-carousel {
// padding-bottom: 10px;
.lazy_img {
  width: 100%;
  height: auto;
}
// }

.statement {
  position: absolute;
  z-index: 100;
  height: 25px;
  width: 70px;
  top: 30px;
  right: 0;
  background-color: rgba($color: #323233, $alpha: 0.7);
  border-radius: 12px 0 0 12px;
  color: $white;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  .statement-title {
    line-height: 23px;
  }
}

.end-text {
  color: white;
  font-size: var(--van-count-down-font-size);
  line-height: 35px;
  display: block;
  background-color: #008cd6;
}

.count-text {
  --van-count-down-line-height: 35px;
  --van-count-down-text-color: #008cd6;
  font-weight: 500;
}
.activity-btn {
  position: absolute;
  top: 20px;
  right: 0;
  width: 65px;
  height: 26px;
  line-height: 26px;
  font-size: 14px;
  text-align: center;
  background-color: rgba(50, 50, 51, 0.7);
  border-radius: 12px 0 0 12px;
  color: #fff;
  padding: 0 6px;
}
</style>
